import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const contactDetailDocumentsState = (state: AppState) =>
    state.contactsAndOrganizations.contacts.contactDetail.documents;

export const overallUploadProgressSelector = createSelector(contactDetailDocumentsState, state => {
    const progress = state.documents
        .map(document => document.uploadProgress)
        // Filter undefined elements with a type guard to make Typescript understand what I want
        .filter((uploadProgress): uploadProgress is number => !!uploadProgress);

    if (progress.length === 0) {
        return 0;
    }

    const sum = progress.reduce((result, item) => {
        return result + item;
    }, 0);
    return sum / progress.length;
});

export const documentsSelector = createSelector(contactDetailDocumentsState, state =>
    state.documents.filter(document => document.uploadProgress === undefined)
);
